import React, { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import api, { apiErr } from "@/lib/api";
import { toast } from "@/components/ui/sonner";

const cls = "w-[64px] rounded-lg border border-[#E3DED4] bg-white px-2 py-1 text-xs text-right tabular outline-none focus:border-[#45423C]";

export function BoardRateControl({ rate, canEdit, onSaved }) {
  const [h, setH] = useState(rate.housing);
  const [f, setF] = useState(rate.feeding);
  useEffect(() => { setH(rate.housing); setF(rate.feeding); }, [rate.housing, rate.feeding]);
  const save = useMutation({
    mutationFn: async () => (await api.put("/budget/board-rate", { housing: Number(h) || 0, feeding: Number(f) || 0 })).data,
    onSuccess: (d) => { onSaved(d); toast.success(`Στέγαση ${d.housing} € / Σίτιση ${d.feeding} € ανά μήνα — εφαρμόστηκε σε όλους`); },
    onError: (e) => toast.error(apiErr(e)),
  });
  const dirty = Number(h) !== rate.housing || Number(f) !== rate.feeding;
  return (
    <div className="flex flex-wrap items-center gap-2 text-xs text-[#6F6A60]" data-testid="board-rate-control">
      <span className="text-[10px] uppercase tracking-wider font-semibold">€ / μήνα εργασίας</span>
      <label className="flex items-center gap-1">Στέγαση
        {canEdit ? <input data-testid="board-rate-housing" type="number" min="0" value={h} onChange={(e) => setH(e.target.value)} className={cls} /> : <b>{rate.housing} €</b>}
      </label>
      <label className="flex items-center gap-1">Σίτιση
        {canEdit ? <input data-testid="board-rate-feeding" type="number" min="0" value={f} onChange={(e) => setF(e.target.value)} className={cls} /> : <b>{rate.feeding} €</b>}
      </label>
      {canEdit && dirty && (
        <button data-testid="board-rate-apply" onClick={() => save.mutate()} disabled={save.isPending}
          className="rounded-full bg-[#45423C] text-white px-3 py-1 text-xs font-semibold disabled:opacity-50">Εφαρμογή σε όλους</button>
      )}
    </div>
  );
}
